import { Controller } from 'stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  connect() {
    flatpickr(
      this.element,
      {
        enableTime: true,
        dateFormat: 'd-m-Y H:i',
        time_24hr: true
      }
    )
  }
}
